export default class Colors {
    static LeftMenuSelectedColor = "#eaeaea";
}
